import { render, staticRenderFns } from "./SpecialrequestMove.vue?vue&type=template&id=2c6c95d1&"
import script from "./SpecialrequestMove.vue?vue&type=script&lang=js&"
export * from "./SpecialrequestMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports